import {
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_START,
  GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_ERROR,
  CLEAR_ATTACHMENT_REQUEST_FOR_SIGNET_STATUS,
} from '../actions/types';

const initialState = {
  requestForSignetStatusAttachmentList: [],
  requestForSignetStatusAttachment: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearAttachmentContent = (state) => {
  return {
    ...state,
    requestForSignetStatusAttachment: {},
  };
};

const findRequestForSignetStatusAttachmentBySignetIdStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const findRequestForSignetStatusAttachmentBySignetId = (state, action) => {
  return {
    ...state,
    requestForSignetStatusAttachment: action.payload,
    error: undefined,
  };
};

const findRequestForSignetStatusAttachmentBySignetIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT:
      return findRequestForSignetStatusAttachmentBySignetId(state, action);
    case GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_START:
      return findRequestForSignetStatusAttachmentBySignetIdStart(state);
    case GET_REQUEST_FOR_SIGNET_STATUS_BY_SIGNET_ATTACHMENT_ERROR:
      return findRequestForSignetStatusAttachmentBySignetIdError(state, action);

    case CLEAR_ATTACHMENT_REQUEST_FOR_SIGNET_STATUS:
      return clearAttachmentContent(state);

    default:
      return state;
  }
}
